import { auth, db } from '../utils/configureFirebase';

/**
 *
 * @param {string} email user email
 * @param {string} password user password
 * @returns {promise} promise returning user info
 */
export const signInUser = async (email, password) => {
  try {
    const { user } = await auth.signInWithEmailAndPassword(email, password);
    return user;
  } catch (error) {
    throw error;
  }
};

/**
 * Signout our user
 */
export const signOutUser = async () => {
  try {
    await auth.signOut();
  } catch (error) {
    throw error;
  }
};

export const sendResetPasswordLink = async (email) => {
  try {
    await auth.sendPasswordResetEmail(email);
  } catch (error) {
    throw error;
  }
};

/**
 * Watch change in detailed user info
 *
 * @param {function} cb callback function providing user info
 * @param {object} options
 * @param options.uid user uid
 * @returns {function} method to unsubscribe
 */
export const watchUserInfo = (cb, options = {}) => {
  if (!options.uid) {
    throw Error('uid is required. Check options parameter.');
  }

  const unsubscribe = db
    .collection('users')
    .doc(options.uid)
    .onSnapshot((user) => {
      if (user.exists) {
        cb(user.data());
      } else {
        cb(null);
      }
    });

  return unsubscribe;
};

/**
 * Watch for user change
 * @param {function} cb callback function providing user
 */
export const watchUserChange = (cb) => {
  const unsubscribe = auth.onAuthStateChanged((user) => {
    if (user) {
      cb(user);
    } else {
      cb(null);
    }
  });
  return unsubscribe;
};

export const changePassword = async (newPassword) => {
  try {
    const user = auth.currentUser;
    const response = await user.updatePassword(newPassword);
    return response;
  } catch (error) {
    throw new Error(error);
  }
};



// WEBPACK FOOTER //
// ./src/services/authServices.js